(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
if (!customElements.get('cart-page')) {
  customElements.define('cart-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.status = this.querySelector('[data-cart-page-status]');
      this.sectionId = this.dataset.sectionId;
      const initialCheckout = this.querySelector('[data-cart-checkout]');
      if (initialCheckout) initialCheckout.disabled = false;
      if (this.status) this.status.textContent = '';
      this.noteTimer = null;
      this.inputTimers = new WeakMap();
      this.pendingQuantities = new Map();
      this.quantityTimers = new Map();
      this.quantityRequests = new Set();
      this.removeLegacyPersonalization();
      this.handlePageShow = (event) => {
        if (!event.persisted) return;
        const checkout = this.querySelector('[data-cart-checkout]');
        if (checkout) checkout.disabled = false;
        this.announce('');
      };
      window.addEventListener('pageshow', this.handlePageShow);
      this.querySelectorAll('quantity-selector input').forEach((input) => { input.dataset.lastValue = input.value; });
      this.addEventListener('prime:quantity-change', (event) => {
        const selector = event.target.closest('quantity-selector[data-line]');
        if (!selector) return;
        this.queueQuantity(selector, event.detail?.quantity, event.detail?.previousQuantity);
      });
      this.addEventListener('change', (event) => {
        const selector = event.target.closest('quantity-selector[data-line]');
        if (selector) {
          window.clearTimeout(this.inputTimers.get(event.target));
          this.inputTimers.delete(event.target);
          this.queueQuantity(selector, Number(event.target.value));
        }
      });
      this.addEventListener('input', (event) => {
        const selector = event.target.closest('quantity-selector[data-line]');
        if (selector) {
          window.clearTimeout(this.inputTimers.get(event.target));
          this.inputTimers.set(event.target, window.setTimeout(() => {
            this.inputTimers.delete(event.target);
            this.queueQuantity(selector, Number(event.target.value));
          }, 250));
          return;
        }
        if (event.target.matches('[data-cart-note]')) {
          window.clearTimeout(this.noteTimer);
          this.noteTimer = window.setTimeout(() => window.PrimeCartApi?.saveNote(event.target.value).catch(() => this.announce('No se pudo guardar la nota')), 500);
        }
      });
      this.addEventListener('click', async (event) => {
        const remove = event.target.closest('[data-cart-page-remove]');
        if (remove) { event.preventDefault(); const selector = this.querySelector(`quantity-selector[data-line="${CSS.escape(remove.dataset.cartPageRemove)}"]`); if (selector) this.queueQuantity(selector, 0); return; }
        if (event.target.closest('[data-clear-cart]')) { event.preventDefault(); this.clear(); }
        const checkout = event.target.closest('[data-cart-checkout]');
        if (checkout) {
          event.preventDefault();
          checkout.disabled = true;
          this.announce('Preparando el pago seguro');
          try {
            const currentCart = await window.PrimeCartApi?.get();
            if (currentCart) await window.PrimeCartApi.removeLegacyPersonalization(currentCart);
            await window.PrimeCartApi?.saveNote(this.querySelector('[data-cart-note]')?.value || '');
            const root = window.Shopify?.routes?.root || '/';
            window.location.assign(`${root}checkout?locale=es-MX`);
          } catch (error) {
            checkout.disabled = false;
            this.announce(error.message);
          }
        }
      });
    }
    disconnectedCallback() { window.removeEventListener('pageshow', this.handlePageShow); }
    async removeLegacyPersonalization() {
      if (!window.PrimeCartApi) return;
      try {
        const currentCart = await window.PrimeCartApi.get();
        const cleanedCart = await window.PrimeCartApi.removeLegacyPersonalization(currentCart, [this.sectionId], '/cart');
        if (cleanedCart !== currentCart) this.replace(cleanedCart);
      } catch (error) {
        this.announce(error.message);
      }
    }
    announce(message) { if (this.status) { this.status.textContent = ''; requestAnimationFrame(() => { this.status.textContent = message; }); } }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify?.currency?.active || 'MXN' }).format(cents / 100); }
    queueQuantity(selector, quantity, previousQuantity = null) {
      if (!window.PrimeCartApi) { this.announce('El carrito no está disponible. Recarga la página e intenta de nuevo.'); return; }
      const input = selector.querySelector('input');
      const key = selector.dataset.line;
      const pending = this.pendingQuantities.get(key);
      const confirmed = pending?.confirmed ?? Number(input.dataset.lastValue || previousQuantity || input.value);
      const next = Math.max(0, Math.floor(Number.isFinite(Number(quantity)) ? Number(quantity) : confirmed));
      this.pendingQuantities.set(key, { quantity: next, confirmed, reference: selector.dataset.reference || pending?.reference || '' });
      this.renderOptimistic();
      window.clearTimeout(this.quantityTimers.get(key));
      this.quantityTimers.set(key, window.setTimeout(() => this.commitQuantity(key), 90));
    }
    pendingQuantityFor(line) {
      for (const [key, pending] of this.pendingQuantities) {
        if (key === line.dataset.cartLine) return pending.quantity;
        const lineReference = line.querySelector('quantity-selector')?.dataset.reference || '';
        if (lineReference && pending.reference === lineReference) return pending.quantity;
      }
      return Number(line.dataset.cartLineQuantity || 0);
    }
    renderOptimistic() {
      let total = 0;
      let displayCount = 0;
      this.querySelectorAll('[data-cart-line]').forEach((line) => {
        const confirmedQuantity = Math.max(1, Number(line.dataset.cartLineQuantity || 1));
        const unitPrice = Number(line.dataset.cartLinePrice || 0) / confirmedQuantity;
        const quantity = this.pendingQuantityFor(line);
        const selector = line.querySelector('quantity-selector');
        const input = selector?.querySelector('input');
        if (input) input.value = quantity;
        const linePrice = Math.round(unitPrice * quantity);
        const label = line.querySelector('[data-cart-line-price-label]');
        if (label) label.textContent = this.money(linePrice);
        total += linePrice;
        displayCount += quantity;
      });
      const totalLabel = this.querySelector('[data-cart-total]');
      if (totalLabel) totalLabel.textContent = this.money(total);
      document.querySelectorAll('.site-header__cart').forEach((link) => {
        const count = link.querySelector('span');
        if (count) count.textContent = displayCount;
        if (link.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', displayCount));
      });
    }
    updateConfirmedBaseline(cart) {
      cart.items.forEach((item) => {
        const line = this.querySelector(`[data-cart-line="${CSS.escape(item.key)}"]`);
        if (!line) return;
        line.dataset.cartLineQuantity = String(item.quantity);
        line.dataset.cartLinePrice = String(item.final_line_price);
        const input = line.querySelector('quantity-selector input');
        if (input) input.dataset.lastValue = String(item.quantity);
      });
      const total = this.querySelector('[data-cart-total]');
      if (total) total.dataset.cartTotalCents = String(cart.total_price);
    }
    async commitQuantity(key) {
      if (this.quantityRequests.has(key)) return;
      const pending = this.pendingQuantities.get(key);
      if (!pending || !window.PrimeCartApi) return;
      const selector = this.querySelector(`quantity-selector[data-line="${CSS.escape(key)}"]`);
      if (!selector) return;
      selector.setAttribute('aria-busy', 'true');
      this.quantityRequests.add(key);
      this.announce('Actualizando carrito');
      try {
        const cart = await window.PrimeCartApi.updateBundle(key, pending.quantity, pending.reference, [this.sectionId], '/cart');
        const latest = this.pendingQuantities.get(key);
        if (latest === pending) {
          this.pendingQuantities.delete(key);
          this.replace(cart);
        } else {
          latest.confirmed = pending.quantity;
          this.updateConfirmedBaseline(cart);
          this.renderOptimistic();
        }
      } catch (error) {
        this.pendingQuantities.delete(key);
        this.renderOptimistic();
        this.querySelectorAll('quantity-selector').forEach((candidate) => candidate.removeAttribute('aria-busy'));
        this.announce(error.message);
      } finally {
        this.quantityRequests.delete(key);
        selector.removeAttribute('aria-busy');
        if (this.pendingQuantities.has(key)) this.commitQuantity(key);
      }
    }
    async clear() {
      if (!window.PrimeCartApi) return;
      this.setAttribute('aria-busy', 'true');
      this.announce('Vaciando carrito');
      try {
        const cart = await window.PrimeCartApi.clear([this.sectionId], '/cart');
        this.replace(cart);
      } catch (error) {
        this.removeAttribute('aria-busy');
        this.announce(error.message);
      }
    }
    replace(cart) {
      const html = cart.sections?.[this.sectionId];
      if (!html) { window.location.reload(); return; }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-cart-page]');
      if (!replacement) { window.location.reload(); return; }
      this.replaceWith(replacement);
      document.querySelectorAll('.site-header__cart').forEach((link) => {
        const displayCount = cart.item_count;
        link.querySelector('span').textContent = displayCount;
        link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', displayCount));
      });
      window.PrimeMotion?.initialize(replacement);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.prime-contact__form').forEach((form) => {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    const submit = form.querySelector('[data-contact-submit]');
    submit?.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('product-rail')) return;
  customElements.define('product-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const rail = this.querySelector('[data-product-rail]');
      const section = this.closest('.featured-products');
      section?.querySelector('[data-rail-previous]')?.addEventListener('click', () => rail?.scrollBy({ left: -(rail.clientWidth * .78), behavior: 'smooth' }));
      section?.querySelector('[data-rail-next]')?.addEventListener('click', () => rail?.scrollBy({ left: rail.clientWidth * .78, behavior: 'smooth' }));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!window.PrimeHeaderScroll) {
  window.PrimeHeaderScroll = {
    frameRequested: false,
    headers: new Set(),
    update() {
      this.frameRequested = false;
      this.headers.forEach((header) => {
        if (!header.isConnected) { this.headers.delete(header); return; }
        header.classList.toggle('is-compact', window.scrollY > 48);
      });
    },
    request() {
      if (this.frameRequested) return;
      this.frameRequested = true;
      requestAnimationFrame(() => this.update());
    }
  };
  window.addEventListener('scroll', () => window.PrimeHeaderScroll.request(), { passive: true });
}

if (!window.PrimePredictiveSearch) {
  window.PrimePredictiveSearch = {
    cache: new Map(),
    maxCacheEntries: 40,
    normalizeQuery(query) {
      return query.trim().replace(/\s+/g, ' ').slice(0, 100);
    },
    cacheKey(surface, query) {
      const resources = surface.dataset.searchShowCollections === 'true' ? 'collections' : 'products';
      return `${surface.dataset.searchLimit || '6'}:${resources}:${query.toLocaleLowerCase('es')}`;
    },
    remember(key, html) {
      this.cache.delete(key);
      this.cache.set(key, html);
      while (this.cache.size > this.maxCacheEntries) {
        this.cache.delete(this.cache.keys().next().value);
      }
    },
    highlightMatches(container, query) {
      if (!container || !query || query.length < 2) return;
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escaped})`, 'gi');
      container.querySelectorAll('[data-predictive-title]').forEach((element) => {
        const text = element.textContent;
        if (!text) return;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(text)) !== null) {
          fragment.append(document.createTextNode(text.slice(lastIndex, match.index)));
          const mark = document.createElement('mark');
          mark.textContent = match[0];
          fragment.append(mark);
          lastIndex = match.index + match[0].length;
        }
        fragment.append(document.createTextNode(text.slice(lastIndex)));
        element.replaceChildren(fragment);
      });
    },
    bindSurface(surface) {
      if (!surface || surface.dataset.predictiveReady) return;
      surface.dataset.predictiveReady = 'true';
      const input = surface.querySelector('[data-predictive-input]');
      const results = surface.querySelector('[data-search-results]');
      const hint = surface.querySelector('[data-search-hint]');
      const status = surface.querySelector('[data-search-status]');
      const merchandisingWrap = surface.querySelector('[data-search-merchandising-wrap]');
      const dropdown = surface.querySelector('[data-search-dropdown]');
      const isDialog = surface.matches('[data-search-dialog]');
      let searchTimer;
      let searchRequest;
      let requestSequence = 0;

      const setExpanded = (expanded) => {
        input?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const showDropdown = () => {
        if (!dropdown) return;
        dropdown.hidden = false;
        setExpanded(true);
      };

      const hideDropdown = () => {
        if (!dropdown) return;
        dropdown.hidden = true;
        setExpanded(false);
      };

      const toggleMerchandising = (visible) => {
        if (!merchandisingWrap) return;
        const hasMerchandising = merchandisingWrap.querySelector('[data-search-has-merchandising]');
        merchandisingWrap.hidden = !visible || !hasMerchandising;
      };

      const toggleHint = (visible) => {
        if (!hint) return;
        hint.hidden = !visible;
      };

      const resetSurface = () => {
        requestSequence += 1;
        searchRequest?.abort();
        searchRequest = null;
        surface.classList.remove('is-loading');
        results?.removeAttribute('aria-busy');
        results?.replaceChildren();
        const hasMerchandising = merchandisingWrap?.querySelector('[data-search-has-merchandising]');
        toggleMerchandising(Boolean(hasMerchandising));
        toggleHint(!hasMerchandising);
        status.textContent = '';
        if (isDialog) setExpanded(false);
      };

      const renderSearch = (html, query) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const resultRoot = parsed.querySelector('[data-predictive-results]');
        results.replaceChildren();
        if (resultRoot) {
          results.append(...resultRoot.childNodes);
          this.highlightMatches(results, query);
          toggleMerchandising(false);
          toggleHint(false);
          const hasOptions = Boolean(results.querySelector('[role="option"]'));
          status.textContent = hasOptions
            ? surface.dataset.searchResultsLabel.replace('__TERMS__', query)
            : surface.dataset.searchEmpty;
          if (isDialog) setExpanded(true);
        } else {
          toggleMerchandising(false);
          toggleHint(false);
          status.textContent = surface.dataset.searchEmpty;
          if (isDialog) setExpanded(false);
        }
        if (dropdown) showDropdown();
      };

      const requestSearch = async (query) => {
        const key = this.cacheKey(surface, query);
        requestSequence += 1;
        const currentSequence = requestSequence;
        searchRequest?.abort();
        if (this.cache.has(key)) {
          const cachedHtml = this.cache.get(key);
          this.remember(key, cachedHtml);
          surface.classList.remove('is-loading');
          results?.removeAttribute('aria-busy');
          renderSearch(cachedHtml, query);
          return;
        }
        searchRequest = new AbortController();
        surface.classList.add('is-loading');
        results?.setAttribute('aria-busy', 'true');
        status.textContent = surface.dataset.searchLoading;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(`${root}search/suggest`, window.location.origin);
          url.searchParams.set('q', query);
          const resourceTypes = surface.dataset.searchShowCollections === 'true' ? 'product,collection' : 'product';
          url.searchParams.set('resources[type]', resourceTypes);
          url.searchParams.set('resources[limit]', surface.dataset.searchLimit || '6');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          url.searchParams.set('section_id', 'predictive-search');
          const response = await fetch(url, { signal: searchRequest.signal });
          if (!response.ok) throw new Error('La búsqueda no está disponible');
          const html = await response.text();
          if (currentSequence !== requestSequence) return;
          this.remember(key, html);
          renderSearch(html, query);
        } catch (error) {
          if (error.name === 'AbortError' || currentSequence !== requestSequence) return;
          const errorMessage = document.createElement('p');
          errorMessage.className = 'predictive-search-results__empty';
          errorMessage.textContent = surface.dataset.searchError;
          results.replaceChildren(errorMessage);
          toggleMerchandising(false);
          toggleHint(false);
          if (isDialog) setExpanded(false);
          status.textContent = surface.dataset.searchError;
        } finally {
          if (currentSequence === requestSequence) {
            surface.classList.remove('is-loading');
            results?.removeAttribute('aria-busy');
            searchRequest = null;
          }
        }
      };

      const handleInput = () => {
        window.clearTimeout(searchTimer);
        input.setCustomValidity('');
        const query = this.normalizeQuery(input.value);
        if (query.length < 2) {
          resetSurface();
          if (dropdown) showDropdown();
          return;
        }
        if (dropdown) showDropdown();
        searchTimer = window.setTimeout(() => requestSearch(query), 200);
      };

      const focusResultLinks = (event) => {
        const links = [...surface.querySelectorAll('[data-search-results] a')];
        if (!links.length) return;
        const current = links.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          links[current < links.length - 1 ? current + 1 : 0].focus();
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          links[current > 0 ? current - 1 : links.length - 1].focus();
        }
      };

      input?.addEventListener('input', handleInput);
      input?.addEventListener('click', () => {
        if (dropdown) {
          const query = this.normalizeQuery(input.value);
          if (query.length >= 2 && results?.childElementCount) showDropdown();
          else {
            resetSurface();
            showDropdown();
          }
        }
      });

      surface.addEventListener('submit', (event) => {
        const query = this.normalizeQuery(input.value);
        if (!query) {
          event.preventDefault();
          input.value = '';
          input.setCustomValidity(surface.dataset.searchRequired || 'Escribe una búsqueda.');
          input.reportValidity();
          return;
        }
        input.setCustomValidity('');
        input.value = query;
      });

      if (dropdown) {
        const handleDocumentClick = (event) => {
          if (!surface.isConnected) {
            document.removeEventListener('click', handleDocumentClick);
            return;
          }
          if (!surface.contains(event.target)) hideDropdown();
        };
        document.addEventListener('click', handleDocumentClick);
      }

      surface.addEventListener('keydown', (event) => {
        if (dropdown && event.key === 'Escape') {
          event.preventDefault();
          input.focus({ preventScroll: true });
          hideDropdown();
          return;
        }
        focusResultLinks(event);
      });

      if (isDialog) surface.addEventListener('prime:search-close', () => {
        window.clearTimeout(searchTimer);
        resetSurface();
      });

      resetSurface();
    }
  };
}

const initializeHeaders = (scope = document) => {
  scope.querySelectorAll('[data-site-header]').forEach((header) => {
    if (header.dataset.ready) return;
    header.dataset.ready = 'true';
    const trigger = header.querySelector('[data-menu-trigger]');
    const menu = header.querySelector('[data-mobile-menu]');
    const panel = menu?.querySelector('.mobile-menu__panel');
    const close = header.querySelector('[data-menu-close]');
    const searchTrigger = header.querySelector('[data-search-open]');
    const searchDialog = header.querySelector('[data-search-dialog]');
    const searchClose = header.querySelector('[data-search-close]');
    const searchInput = header.querySelector('[data-search-dialog] [data-predictive-input]');
    const closeMenu = () => {
      if (!menu || menu.hidden) return;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      menu.classList.remove('is-open');
      const finish = () => {
        menu.hidden = true;
        trigger.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else window.setTimeout(finish, 320);
    };
    const openMenu = () => {
      if (!menu || !menu.hidden) return;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      requestAnimationFrame(() => menu.classList.add('is-open'));
      window.setTimeout(() => panel?.focus(), 30);
    };
    trigger?.addEventListener('click', openMenu);
    close?.addEventListener('click', closeMenu);
    menu?.querySelectorAll('[data-mobile-disclosure]').forEach((disclosure) => {
      const summary = disclosure.querySelector('summary');
      const syncExpanded = () => summary?.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
      syncExpanded();
      disclosure.addEventListener('toggle', syncExpanded);
    });
    menu?.addEventListener('click', (event) => { if (event.target === menu) closeMenu(); });
    menu?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
      if (event.key !== 'Tab') return;
      const focusable = [...menu.querySelectorAll('a, button, summary, [tabindex]:not([tabindex="-1"])')].filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const closeSearch = () => {
      if (!searchDialog?.open || searchDialog.classList.contains('is-closing')) return;
      searchDialog?.dispatchEvent(new CustomEvent('prime:search-close'));
      document.body.classList.remove('search-open');
      const finish = () => {
        searchDialog.classList.remove('is-closing');
        searchDialog.close();
        searchTrigger?.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else {
        searchDialog.classList.add('is-closing');
        window.setTimeout(finish, 220);
      }
    };
    const openSearch = (event) => {
      if (!searchDialog) return;
      event?.preventDefault();
      searchDialog.showModal();
      document.body.classList.add('search-open');
      searchInput?.focus();
      if (searchInput) {
        const searchResults = searchDialog.querySelector('[data-search-results]');
        searchInput.setAttribute('aria-expanded', searchResults?.childElementCount ? 'true' : 'false');
      }
    };
    searchTrigger?.addEventListener('click', openSearch);
    searchClose?.addEventListener('click', closeSearch);
    searchDialog?.addEventListener('click', (event) => { if (event.target === searchDialog) closeSearch(); });
    searchDialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeSearch(); });
    searchDialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSearch();
      }
    });
    header.querySelectorAll('[data-predictive-surface]').forEach((surface) => {
      window.PrimePredictiveSearch.bindSurface(surface);
    });
    window.PrimeHeaderScroll.headers.add(header);
    window.PrimeHeaderScroll.update();
  });
};
initializeHeaders();
document.addEventListener('shopify:section:load', (event) => initializeHeaders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
const initializeHeroEntrances = (scope = document) => {
  const heroes = [];
  if (scope.matches?.('[data-hero]')) heroes.push(scope);
  heroes.push(...(scope.querySelectorAll?.('[data-hero]') || []));
  requestAnimationFrame(() => heroes.forEach((hero) => hero.classList.add('is-entered')));
};
initializeHeroEntrances();
document.addEventListener('shopify:section:load', (event) => initializeHeroEntrances(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready || !this.dataset.url) return;
      this.dataset.ready = 'true';
      fetch(this.dataset.url).then((response) => response.text()).then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
        if (html?.innerHTML.trim()) this.innerHTML = html.innerHTML;
      }).catch(() => {});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-info')) {
  customElements.define('product-info', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      this.optionGroups = [...this.querySelectorAll('[data-option-index]')];
      this.selected = this.optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue);
      this.personalizationIndex = this.optionGroups.findIndex((group) => group.hasAttribute('data-personalization-option'));
      this.sizeGuideDialog = this.querySelector('[data-size-guide]');
      this.sizeGuideDialog?.addEventListener('click', (event) => { if (event.target === this.sizeGuideDialog) this.closeSizeGuide(); });
      this.sizeGuideDialog?.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); this.closeSizeGuide(); } });
      this.sizeGuideDialog?.addEventListener('close', () => { document.body.classList.remove('drawer-open'); this.sizeGuideTrigger?.focus(); });
      this.addEventListener('click', (event) => this.handleClick(event));
      this.querySelector('[data-personalization-toggle]')?.addEventListener('change', (event) => this.togglePersonalization(event.target.checked));
      const nameInput = this.querySelector('[data-personalization-name]');
      const numberInput = this.querySelector('[data-personalization-number]');
      nameInput?.addEventListener('input', () => window.PrimePersonalization?.sanitizeName(nameInput));
      numberInput?.addEventListener('input', () => window.PrimePersonalization?.sanitizeNumber(numberInput));
      if (this.personalizationIndex >= 0 && this.selected[this.personalizationIndex] === 'Personalizado') this.togglePersonalization(false);
      else this.updateOptions();
    }
    togglePersonalization(enabled) {
      const toggle = this.querySelector('[data-personalization-toggle]');
      const fields = this.querySelector('[data-personalization-fields]');
      if (!fields) return;
      toggle?.setAttribute('aria-expanded', String(enabled));
      fields.hidden = !enabled;
      fields.querySelectorAll('input').forEach((input) => { input.disabled = !enabled; input.required = enabled; });
      if (this.personalizationIndex >= 0) {
        this.selected[this.personalizationIndex] = enabled ? 'Personalizado' : 'Sin personalizar';
        const group = this.optionGroups[this.personalizationIndex];
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const active = button.dataset.optionValue === this.selected[this.personalizationIndex];
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.updateVariant();
      }
      if (enabled) fields.querySelector('input')?.focus();
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100); }
    handleClick(event) {
      const option = event.target.closest('[data-option-value]');
      if (option) {
        const group = option.closest('[data-option-index]'); const index = Number(group.dataset.optionIndex);
        this.selected[index] = option.dataset.optionValue;
        group.querySelectorAll('[data-option-value]').forEach((button) => { const active = button === option; button.classList.toggle('is-selected', active); button.setAttribute('aria-pressed', String(active)); });
        group.querySelector('[data-selected-option]').textContent = option.dataset.optionValue;
        this.updateVariant();
      }
      const media = event.target.closest('[data-media-target]');
      if (media) this.showMedia(media.dataset.mediaTarget);
      if (event.target.closest('[data-size-guide-open]')) { event.preventDefault(); this.openSizeGuide(event.target.closest('[data-size-guide-open]')); return; }
      if (event.target.closest('[data-size-guide-close]')) { event.preventDefault(); this.closeSizeGuide(); return; }
    }
    openSizeGuide(trigger) {
      const dialog = this.sizeGuideDialog;
      if (!dialog) return;
      this.sizeGuideTrigger = trigger || document.activeElement;
      dialog.classList.remove('is-closing');
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('drawer-open');
      dialog.querySelector('[data-size-guide-close]')?.focus();
    }
    closeSizeGuide() {
      const dialog = this.sizeGuideDialog;
      if (!dialog?.open || dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
      dialog.classList.add('is-closing');
      window.setTimeout(() => { dialog.classList.remove('is-closing'); dialog.close(); }, 320);
    }
    updateVariant() {
      const variant = this.variants.find((candidate) => candidate.options.every((value, index) => value === this.selected[index]));
      const id = this.querySelector('[data-variant-id]'); const add = this.querySelector('[data-add-to-cart]');
      if (!variant) { id.value = ''; add.disabled = true; this.querySelector('[data-add-label]').textContent = add.dataset.unavailable || 'No disponible'; return; }
      id.value = variant.id; add.disabled = !variant.available;
      this.querySelector('[data-add-label]').textContent = variant.available ? add.dataset.available || 'Añadir al carrito' : add.dataset.soldOut || 'Agotado';
      this.querySelector('[data-current-price]').textContent = this.money(variant.price);
      const compare = this.querySelector('[data-compare-price]');
      const badge = this.querySelector('[data-save-badge]');
      const priceRoot = this.querySelector('[data-price]');
      const onSale = variant.compare_at_price > variant.price;
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = variant.compare_at_price ? this.money(variant.compare_at_price) : '';
      }
      if (badge) {
        if (onSale) {
          const savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          badge.hidden = false;
          const template = badge.dataset.saveTemplate || 'Ahorra __PERCENT__%';
          badge.textContent = template.replace('__PERCENT__', savings);
        } else {
          badge.hidden = true;
        }
      }
      priceRoot?.classList.toggle('price--on-sale', onSale);
      const availability = this.querySelector('[data-availability]');
      availability.textContent = variant.available ? this.dataset.inStock || 'Disponible' : this.dataset.soldOut || 'Agotado';
      availability.classList.toggle('is-available', variant.available);
      history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
      if (variant.featured_media?.id) this.showMedia(variant.featured_media.id);
      this.updateOptions();
    }
    updateOptions() {
      this.querySelectorAll('[data-option-index]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const available = this.variants.some((variant) => variant.available && variant.options.every((value, optionIndex) => optionIndex === index ? value === button.dataset.optionValue : value === this.selected[optionIndex]));
          button.disabled = !available;
        });
      });
    }
    showMedia(id) {
      const target = this.querySelector(`[data-media-id="${id}"]`); if (!target) return;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
      this.querySelectorAll('[data-media-target]').forEach((button) => button.toggleAttribute('aria-current', button.dataset.mediaTarget === String(id)));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
